/**
 * Loads the full Tailwind build (assets/css/tailwind.css) on every route but the landing page.
 *
 * The landing page is prerendered with only its own utilities inlined (tailwind-landing.css),
 * so its HTML stays small. Every other page needs the rest before it renders: the stylesheet
 * starts loading as the app starts there, and navigation away from `/` waits for it.
 */
export default defineNuxtPlugin(() => {
  let loading: Promise<unknown> | null = null
  async function loadAppStyles() {
    loading ??= import('~/assets/css/tailwind.css')
    return loading
  }

  addRouteMiddleware('app-styles', async (to) => {
    if (to.path !== '/')
      await loadAppStyles()
  }, { global: true })

  if (window.location.pathname !== '/')
    void loadAppStyles()
})
